export const HeaderBanner = () => {
  return <div id="banner-container" />;
};
